import { render } from "./IntegrationEditPage.vue?vue&type=template&id=43f56456"
import script from "./IntegrationEditPage.vue?vue&type=script&lang=js"
export * from "./IntegrationEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__